import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store/store";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import { db, balaCollection, userDataCollection } from "@/firebase";
import RadioTable from "@/components/RadioTable";
import { Module } from "@/store/enums";

@Component
export default class WritingTask2Rating extends Vue {
  dialog = false;
  valid = true;
  private _questions: [
    { question: string; responses: Array<string>; answer: number }
  ];
  passage: string;
  private header: any;

  constructor() {
    super();
    this._questions = this.$store.getters.balaWRatings.writingTask2;
    this.passage = this.$store.getters.balaWT2Passage;
    this.header = this.$store.getters.balaWRatings.writingTask2Header;
  }

  beforeCreate() {
    this._questions = this.$store.getters.balaWRatings.writingTask2;
    this.passage = this.$store.state.balaWT2Passage;
    this.header = this.$store.getters.balaWRatings.writingTask2Header;
  }

  getData() {
    let data: any = [];
    this._questions.forEach(function(item: any) {
      data.push({
        question: item.question,
        answer: item.answer, // answer '1' maps to '0' (and so on...) on the responses list.
        qid: item.qid
      });
    });
    return data;
  }

  private isComplete() {
    return this.$store.getters.balaSections[8].sectionProgress.Rating == 100;
  }

  submit() {
    if (this.$store.getters.balaSections[8].sectionProgress.Rating != 100) {
      var thisUser = this.$store.getters.user;
      var uid = thisUser.data.uid;

      let timepoint = this.$store.getters.balaTimepointStr;
      let data = this.getData();

      // Store question answers
      userDataCollection
        .doc(uid)
        .collection("bala")
        .doc(timepoint)
        .collection("responses")
        .doc("writingTask2")
        .set(
          {
            RatingAnswers: data
          },
          { merge: true }
        )
        .then(function() {
          userDataCollection
            .doc(uid)
            .collection("bala")
            .doc(timepoint)
            .update({
              "completionStatus.writingTask2.rating": {
                status: true,
                dateCompleted: Date.now()
              }
            });
        })
        .catch(function(error) {});

      // Update progress           in $store
      this.$store.dispatch("updateBalaProgress", {
        section: "Writing Task 2",
        subsection: "Ratings"
      });
    }
    this.$router.push({ name: "balaOutro" });
  }

  hasCompleted(completed: boolean) {
    this.valid = completed;
  }

  stateLoaded() {
    return (
      this.$store.getters.balaWRatings.writingTask2Loaded &&
      !!this.$store.getters.balaWRatings.writingTask2Header
    );
  }

  main() {
    return (
      <Card
        title="How do you think you did?"
        mod={Module.BALA}
        topButton={{
          label: "Show me my writing",
          callbackfn: () => {
            this.dialog = true;
          }
        }}
      >
        <div slot="mainContent">
          <v-dialog v-model={this.dialog}>
            <v-card class="elevation-12">
              <v-toolbar dark color="secondary">
                <v-toolbar-title class="justify-center">
                  What I wrote
                </v-toolbar-title>
              </v-toolbar>
              <v-textarea
                v-model={
                  this.$store.getters.balaWResponse.writingTask2[0].answer[
                    "afterEdit"
                  ]
                }
                disabled
                class="mx-4"
                rows="16"
              ></v-textarea>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="secondary"
                  onClick={() => {
                    this.dialog = false;
                  }}
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-form ref="form" v-model={this.valid}>
            <RadioTable
              questions={this._questions}
              onUpdate={this.hasCompleted}
              fixHeader={true}
              disabled={this.isComplete()}
              labelType={this.$store.getters.balaWRatings.writingTask2Header}
            ></RadioTable>
          </v-form>
        </div>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn disabled={!this.valid} color="secondary" onClick={this.submit}>
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }

  render(h: CreateElement) {
    return this.stateLoaded() ? this.main() : "";
  }
}

const component = WritingTask2Rating;
